import styled from 'styled-components';
import { colorCents } from 'common/styles/palette';
import { subheadlineXsFontSize, headlineLargeFontSize } from 'common/styles/typography';
import { containerPaddingM } from 'common/styles/variables';

export const ErrorMessageHeader = styled.div`
    max-width: 700px;
`;

export const ErrorMessageHeaderTitle = styled.div`
    font-size: ${headlineLargeFontSize};
    font-weight: 700;
    margin-bottom: ${containerPaddingM};
`;

export const ErrorMessageHeaderDescription = styled.div`
    max-width: 30rem;
    margin: 0 auto;
    font-size: small;
    font-weight: normal;
    text-align: center;
`;

export const ErrorMessageGreenDot = styled.div`
    height: ${subheadlineXsFontSize};
    width: ${subheadlineXsFontSize};
    display: flex;
    background-color: ${colorCents};
    border-radius: 50%;
    margin-left: ${subheadlineXsFontSize};
`;
